import moment from "moment";
import { AxiosResponse } from "axios";
import { useCallback, useEffect, useState } from "react";
import {
  getBlocks,
  getDistricts,
  getGrades,
  getSchools,
} from "../../../Services/Reports/ReportService";
import { TypeBlock, TypeDistrict, TypeGrade, TypeSchool } from "../../../types";
const useFilters = (
  hasWeekMonthFilter?: boolean,
  hasDayWeekFilter?: boolean
) => {
  const [districtList, setDistrictList] = useState<TypeDistrict[]>([]);
  const [blockList, setBlockList] = useState<TypeBlock[]>([]);
  const [schoolList, setSchoolList] = useState<TypeSchool[]>([]);
  const [gradeList, setGradeList] = useState<TypeGrade[]>([]);

  const [selectedFilters, setSelectedFilters] = useState<
    | {
        district: { id: number; name: string };
        block?: { id: number; name: string };
        school?: { id: number; name: string };
        grade?: { id: number; name: string };
        date?: { start_date: string; end_date: string };
      }
    | undefined
  >();
  useEffect(() => {
    if (hasWeekMonthFilter || hasDayWeekFilter) {
      setSelectedFilters((prev) => ({
        ...prev,
        date: {
          start_date: moment(
            hasWeekMonthFilter ? moment().subtract(7, "days") : undefined
          ).format("YYYY-MM-DD"),
          end_date: moment(moment().add(1, "days")).format("YYYY-MM-DD"),
        },
      }));
    }
  }, [hasDayWeekFilter, hasWeekMonthFilter]);

  const handleSelect = (
    value: any,
    type: "district" | "block" | "school" | "grade" | "date"
  ) => {
    setSelectedFilters((prev) => ({ ...prev, [type]: value }));
    if (type === "district") {
      setSelectedFilters((prev) => ({
        ...prev,
        district: value,
        block: undefined,
        school: undefined,
        grade: undefined,
      }));
      setSchoolList([]);
    } else if (type === "block") {
      setSelectedFilters((prev) => ({
        ...prev,
        school: undefined,
        grade: undefined,
      }));
    }
  };
  const resetSelectedFilters = () => {
    if (hasWeekMonthFilter || hasDayWeekFilter) {
      setSelectedFilters((prev) => ({
        district: undefined,
        date: {
          start_date: moment(
            hasWeekMonthFilter ? moment().subtract(7, "days") : undefined
          ).format("YYYY-MM-DD"),
          end_date: moment(moment().add(1, "days")).format("YYYY-MM-DD"),
        },
      }));
    } else {
      setSelectedFilters(undefined);
    }
  };

  const getDistrictList = useCallback(() => {
    getDistricts()
      .then((response: AxiosResponse) => {
        setDistrictList(response?.data?.data);
      })
      .catch((error) => {
        console.log("Error caught: ", error?.response);
      });
  }, []);

  const getBlockList = (districtId: number) => {
    getBlocks(districtId)
      .then((response: AxiosResponse) => {
        setBlockList(response?.data?.data);
      })
      .catch((error) => {
        console.log("Error caught: ", error?.response);
      });
  };
  const getSchoolList = (blockId: number) => {
    getSchools(blockId)
      .then((response: AxiosResponse) => {
        setSchoolList(response?.data?.data);
      })
      .catch((error) => {
        console.log("Error caught: ", error?.response);
      });
  };
  const getGradeList = useCallback(() => {
    getGrades().then(
      (response: AxiosResponse) => {
        // console.log("Response for grades: ", response?.data?.data);
        setGradeList(response?.data?.data);
      },
      (error) => {
        console.log("Error caught: ", error?.response);
      }
    );
  }, []);
  return {
    selectedFilters,
    handleSelect,
    resetSelectedFilters,
    districtList,
    getDistrictList,
    getBlockList,
    blockList,
    getSchoolList,
    schoolList,
    getGradeList,
    gradeList,
  };
};

export default useFilters;
